import { Translations, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { AveWebstreamView } from "./lazy-view";

const translations: Translations = { de, en };

export const aveWebstreamViewKey = "app/ave-webstream";
export const aveWebstreamViewModule: ViewModule = {
  viewKey: aveWebstreamViewKey,
  viewEl: <AveWebstreamView/>,
  displayNameI18nKey: "aveWebstream:viewName",
  menuIconEl: <span>AVE</span>,
  translations,
};
